import { render, staticRenderFns } from "./special_detail2.vue?vue&type=template&id=e53444fa&scoped=true"
import script from "./special_detail2.vue?vue&type=script&lang=js"
export * from "./special_detail2.vue?vue&type=script&lang=js"
import style0 from "./special_detail2.vue?vue&type=style&index=0&id=e53444fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53444fa",
  null
  
)

export default component.exports